import { useReducer } from "react";
import anna from "../../../assets/anna.svg";
import nikola from "../../../assets/nikola.svg";
import dialogsJSON from "../../../data/dialogs.json";
import { DialogActions, DialogData, DialogReducer } from "../Dialogs";

export const useDialogReducer: DialogReducer = () => {
  const [data, dispatch] = useReducer(
    (data: DialogData, action: DialogActions) => {
      switch (action.type) {
        case "setId":
          return {
            ...data,
            currentId: action.id,
            currentDialogsSequence: data.dialogsJSON[action.id] ?? null,
            currentIndex: 0,
            currentDialog:
              (data.dialogsJSON[action.id] && data.dialogsJSON[action.id][0]) ??
              null,
            currentTextKey:
              (data.dialogsJSON[action.id] &&
                data.dialogsJSON[action.id][0].key) ??
              "",
            currentCharacter:
              data.dialogsJSON[action.id] &&
              data.dialogsJSON[action.id][0].character === "anna"
                ? anna
                : nikola,
            showDialog:
              data.dialogsJSON[action.id] &&
              data.dialogsJSON[action.id][0] &&
              data.dialogsJSON[action.id][0].type === "dialog"
                ? true
                : false,
          };
        case "incrementIndex":
          const newIndex = data.currentIndex + 1;
          return {
            ...data,
            currentIndex: newIndex,
            currentDialog:
              (data.currentDialogsSequence &&
                data.currentDialogsSequence[newIndex]) ??
              null,
            currentTextKey:
              (data.currentDialogsSequence &&
                data.currentDialogsSequence[newIndex] &&
                data.currentDialogsSequence[newIndex].key) ??
              "",
            currentCharacter:
              (data.currentDialogsSequence &&
              data.currentDialogsSequence[newIndex] &&
              data.currentDialogsSequence[newIndex].character === "anna"
                ? anna
                : nikola) ?? "",
            showDialog:
              data.currentDialogsSequence &&
              data.currentDialogsSequence[newIndex] &&
              data.currentDialogsSequence[newIndex].type === "dialog"
                ? true
                : false,
          };
        case "setIndex":
          return {
            ...data,
            currentIndex: action.index,
            currentDialog:
              data.currentDialogsSequence &&
              data.currentDialogsSequence[action.index],
            currentTextKey:
              (data.currentDialogsSequence &&
                data.currentDialogsSequence[action.index].key) ??
              "",
            currentCharacter:
              (data.currentDialogsSequence &&
              data.currentDialogsSequence[action.index].character === "anna"
                ? anna
                : nikola) ?? "",
            showDialog:
              data.currentDialogsSequence &&
              data.currentDialogsSequence[action.index] &&
              data.currentDialogsSequence[action.index].type === "dialog"
                ? true
                : false,
          };
        default:
          return { ...data };
      }
    },
    {
      dialogsJSON: dialogsJSON,
      currentId: "",
      currentIndex: 0,
      currentCharacter: "",
      currentTextKey: "",
      currentDialog: null,
      showDialog: false,
    } as DialogData
  );

  //  deprecated for the moment
  // const middleware = (action: DialogActions) => {
  //   switch (action.type) {
  //     default:
  //       break;
  //   }

  //   dispatch(action);
  // };

  return { data, dispatch };
};
